import React, { FC } from 'react';
import { Row, Column } from '../../../../../components/grid/Grid';
import { Article } from '../../legislationCode.types';
import { Hyperlink } from '../../../../../components/Hyperlink';
import styles from './legislation_articles_content.module.scss';
import { getDateKey } from '../../../../../utils/date-utils/dateUtils';
import { buildUrlWithParameters } from '../../../../../utils/url-utils/urlUtils';

type Props = {
  articles: Article[];
  date: string;
  source: string;
};

export const LegislationArticlesContent: FC<Props> = ({
  articles,
  date,
  source,
}) => {
  const today = getDateKey(new Date());
  return (
    <>
      {articles.map(({ number, content, articleId, url }) => (
        <Row key={articleId} className={styles.rowMargin}>
          <Column small={12} medium={2}>
            <Hyperlink
              href={buildUrlWithParameters(
                url,
                (date && date !== today && { dateKey: date }) || {},
              )}
              source={source}
              className={styles.articleLink}
            >
              Article {number}
            </Hyperlink>
          </Column>
          <Column small={12} medium={7}>
            <div dangerouslySetInnerHTML={{ __html: content }} />
          </Column>
        </Row>
      ))}
    </>
  );
};
